import { useState } from "react";
import { motion } from "framer-motion";

export default function NewsletterLuxury() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSent(true);
    setTimeout(() => {
      setSent(false);
      setEmail("");
    }, 2400);
  };

  return (
    <section className="lux-newsletter" aria-labelledby="lux-nl-heading">
      <div className="lux-newsletter__blobs" aria-hidden="true">
        <motion.span
          className="lux-newsletter__blob"
          animate={{ x: [0, 24, 0], y: [0, -16, 0], scale: [1, 1.08, 1] }}
          transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.span
          className="lux-newsletter__blob lux-newsletter__blob--b"
          animate={{ x: [0, -30, 0], y: [0, 20, 0], scale: [1, 1.05, 1] }}
          transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
      <div className="lux-newsletter__inner">
        <h2 id="lux-nl-heading" className="lux-h2">
          Join the inner circle
        </h2>
        <p className="lux-newsletter__sub">Limited releases, styling tips, and private previews.</p>
        <form className="lux-newsletter__form" onSubmit={submit}>
          <motion.label className="lux-newsletter__field" whileFocus={{ scale: 1.01 }}>
            <span className="visually-hidden">Email address</span>
            <input
              type="email"
              name="email"
              autoComplete="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="lux-newsletter__input"
            />
          </motion.label>
          <motion.button type="submit" className="lux-newsletter__btn" whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
            {sent ? "You are in" : "Subscribe"}
          </motion.button>
        </form>
      </div>
    </section>
  );
}
